var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        {
          staticClass: "mt-2",
          attrs: { dense: "", justify: "center", align: "center" },
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  label: "Rows",
                  min: "0",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.rowsCount,
                  callback: function ($$v) {
                    _vm.rowsCount = _vm._n($$v)
                  },
                  expression: "rowsCount",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  label: "Columns",
                  min: "0",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.colsCount,
                  callback: function ($$v) {
                    _vm.colsCount = _vm._n($$v)
                  },
                  expression: "colsCount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-2", attrs: { dense: "" } },
        [_c("v-divider")],
        1
      ),
      _c("v-simple-table", { staticClass: "mt-2" }, [
        _c(
          "tbody",
          _vm._l(_vm.internalModel, function (row, rowIndex) {
            return _c(
              "tr",
              { key: "row-" + rowIndex },
              _vm._l(row, function (cell, colIndex) {
                return _c(
                  "td",
                  { key: "cell-" + rowIndex + "-" + colIndex },
                  [
                    _c("v-text-field", {
                      attrs: { dense: "", outlined: "", "hide-details": "" },
                      on: {
                        input: function ($event) {
                          return _vm.updateModel(
                            rowIndex,
                            colIndex,
                            _vm.internalModel[rowIndex][colIndex]
                          )
                        },
                      },
                      model: {
                        value: _vm.internalModel[rowIndex][colIndex],
                        callback: function ($$v) {
                          _vm.$set(_vm.internalModel[rowIndex], colIndex, $$v)
                        },
                        expression: "internalModel[rowIndex][colIndex]",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }